import { connect } from 'react-redux';

import * as authSelectors from 'store/modules/auth/selectors';
import * as customerSelectors from 'store/modules/customer/selectors';
import { load } from 'store/modules/customer/actions';

import ProfilePage from './ProfilePage';

const mapStateToProps = (state) => ({
  account: customerSelectors.getAccountInfo(state),
  vehicles: customerSelectors.getVehicles(state),
  reviews: customerSelectors.getReviews(state),
  isAuth: authSelectors.getIsUserAuthorized(state),
  currentUserId: authSelectors.getUserId(state),
  isLoading: customerSelectors.getIsLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  onLoadCustomerProfile: (accountId) => dispatch(load(accountId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);
